'use client'

import { adminClient, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { appUrl } from '@/lib/env'

// Same-origin auth handler at /api/auth/formed/* (local route file).
// Better Auth's `createAuthClient` requires an absolute base URL.
// `NEXT_PUBLIC_APP_URL` is this app's own origin — same value the server-side
// auth instance uses to build its baseURL — so cookies stay first-party.
export const authClient = createAuthClient({
  baseURL: `${appUrl()}/api/auth/formed`,
  plugins: [adminClient(), organizationClient()],
})
